import { DeliveryModel } from "./Delivery.model";

export class Delivery extends DeliveryModel {
    vendorTravelDistanceLocalized(): number | null {
        // TODO: Check is project settings use imperial or metric when we add localization
        return this.vendorTravelDistance ? Math.round(this.vendorTravelDistance / 1609.344) : null;
    }
}
